"use strict";
exports.__esModule = true;
var TextareaAutosize_1 = require("./TextareaAutosize");
exports["default"] = TextareaAutosize_1["default"];



//////////////////
// WEBPACK FOOTER
// ./~/react-autosize-textarea/lib/index.js
// module id = 128
// module chunks = 0